import { Repository } from "../../adapters/repository";
import { serializeSettings } from "../../entities/settingsParser";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, settings, nextSettings }) =>
    present(
      repository
        .updatePlanzoneSettings(
          planzone,
          settings,
          serializeSettings(nextSettings),
        )
        .then(() => ({ settings: nextSettings, planzone }))
        .catch(() => Promise.reject({ planzone, settings, nextSettings })),
    );
}

export type { Interactor };

export { createInteractor };
